import {
  IsBoolean,
  IsNumber,
  IsString,
  MaxLength,
  MinLength,
} from 'class-validator';

export class CreateSweetFaceTerminalRequestDto {
  // NOTE: Currently Swagger dcorators will break backoffice-template build, so we use comments instead.
  // @ApiProperty({
  //   description: 'Human readable terminal name',
  //   example: 'Pieshop Terminal 1',
  //   minLength: 1,
  //   maxLength: 255,
  // })
  @IsString()
  @MinLength(1)
  @MaxLength(255)
  name: string;

  // @ApiProperty({
  //   description: 'Bank terminal ID',
  //   minLength: 1,
  //   maxLength: 64,
  // })
  @IsString()
  @MinLength(1)
  @MaxLength(64)
  bankTerminalId: string;

  // @ApiProperty({ description: 'Bank Merchant ID', minLength: 1, maxLength: 64 })
  @IsString()
  @MinLength(1)
  @MaxLength(64)
  bankMID: string;

  @IsNumber()
  // @ApiProperty({
  //   description: 'Pie Merchant ID',
  //   example: 7,
  // })
  pieMerchantId: number;

  @IsNumber()
  // @ApiProperty({
  //    description: 'Pie Merchant Group ID',
  // })
  pieMerchantGroupId: number;

  @IsBoolean()
  // @ApiProperty({
  //    description: 'Enable terminal',
  // })
  enabled: boolean;

  private constructor(
    name: string,
    bankTerminalId: string,
    bankMID: string,
    pieMerchantId: number,
    pieMerchantGroupId: number,
    enabled: boolean
  ) {
    this.name = name;
    this.bankTerminalId = bankTerminalId;
    this.bankMID = bankMID;
    this.pieMerchantId = pieMerchantId;
    this.pieMerchantGroupId = pieMerchantGroupId;
    this.enabled = enabled;
  }

  static create(input: {
    name: string;
    bankTerminalId: string;
    bankMID: string;
    pieMerchantId: number;
    pieMerchantGroupId: number;
    enabled: boolean;
  }): CreateSweetFaceTerminalRequestDto {
    return new CreateSweetFaceTerminalRequestDto(
      input.name,
      input.bankTerminalId,
      input.bankMID,
      input.pieMerchantId,
      input.pieMerchantGroupId,
      input.enabled
    );
  }
}
